/*  Employer Routes */
export default [

  // Offers Control
  // ---------------
  {
    path: '/jobs/offers/me',
    name: 'my-offers',
    meta: {
      name: 'main.routes.my-offers',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/MyOffers.vue')
  },
  {
    path: '/jobs/offers/paymentCallback',
    name: 'offer-payment-callback',
    meta: {
      name: 'main.routes.offer-payment',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/OfferPaymentCallback.vue')
  },
  {
    path: '/jobs/offer',
    name: 'publish-offer',
    meta: {
      name: 'main.routes.publish-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/PublishOffer.vue')
  },
  {
    path: '/jobs/offers/edit/:id',
    name: 'edit-offer',
    meta: {
      name: 'main.routes.edit-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/PublishOffer.vue')
  },
  {
    path: '/jobs/offers/copy/:id',
    name: 'copy-offer',
    meta: {
      name: 'main.routes.copy-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/PublishOffer.vue')
  },
  {
    path: '/jobs/offers/multiprovince/:id',
    name: 'multiprovince-offer',
    meta: {
      name: 'main.routes.multiprovince-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/CopyOffer.vue')
  },
  // ---------------

  // Candidates
  // ---------------
  {
    path: '/jobs/candidates/me',
    name: 'my-candidates',
    meta: {
      name: 'main.routes.my-candidates',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/MyCandidates.vue')
  },
  {
    path: '/jobs/offerCandidates/',
    name: 'offer-candidates',
    props: true,
    meta: {
      name: 'main.routes.offer-candidates',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/offerCandidates.vue')
  },
  {
    path: '/jobs/candidate/:id',
    name: 'one-candidate',
    props: true,
    meta: {
      name: 'main.routes.one-candidate',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/OneCandidate.vue')
  },
  {
    path: '/jobs/external-candidate/:id',
    name: 'external-candidate',
    props: true,
    meta: {
      name: 'main.routes.external-candidate',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/ExternalCandidate.vue')
  },
  {
    path: '/jobs/offerInterns/',
    name: 'offer-interns',
    props: true,
    meta: {
      name: 'main.routes.offer-interns',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/employer/offerInterns.vue')
  },
  // ---------------
]
